import { parseEsriDate } from '../../../util/dateUtils';
import { CellRenderer } from './CellRenderer';

export const DateCellRenderer: CellRenderer = ({ row, column }) => {
  const value = row[column.key];

  const dateValue = value instanceof Date ? value : parseEsriDate(value);
  return <CellRenderer>{dateValue.toLocaleString()}</CellRenderer>;
};
